var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextQuick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1441 2.06354C12.7051 1.90274 12.2263 2.05394 11.9507 2.44033L5.20143 11.937C4.96789 12.2634 4.93519 12.6906 5.11502 13.053C5.29485 13.4153 5.64983 13.6385 6.04451 13.6385H10.5378L10.1245 20.8648C10.0964 21.3424 10.3743 21.772 10.8111 21.9352C10.9278 21.9784 11.0493 22 11.166 22C11.4907 22 11.8013 21.844 12.0021 21.5608L18.7981 11.997C19.0317 11.6706 19.0644 11.2434 18.8869 10.881C18.707 10.521 18.3521 10.2954 17.9574 10.2954H13.415L13.8284 3.13392C13.8564 2.65633 13.5785 2.22433 13.1395 2.06354H13.1441ZM17.9597 11.2962C17.9597 11.2962 18.0018 11.2962 18.0204 11.3346C18.0391 11.373 18.0204 11.397 18.0158 11.4066L11.2198 20.9704C11.2081 20.9872 11.1894 21.0136 11.1404 20.9944C11.0913 20.9776 11.0936 20.944 11.0936 20.9248L11.5374 13.1681C11.5467 13.0314 11.4977 12.897 11.4043 12.7962C11.3132 12.6954 11.1847 12.6402 11.0493 12.6402H6.04217C6.04217 12.6402 6.00014 12.6402 5.98145 12.6018C5.96277 12.5634 5.98145 12.537 5.98612 12.5298L12.7354 3.02832C12.7448 3.01632 12.7565 2.99712 12.7845 2.99712C12.7938 2.99712 12.8032 2.99712 12.8125 3.00192C12.8615 3.01872 12.8592 3.05232 12.8592 3.07152L12.4155 10.7634C12.4061 10.9002 12.4552 11.037 12.5486 11.1354C12.6397 11.2362 12.7681 11.2914 12.9036 11.2914H17.9621L17.9597 11.2962Z",
    fill: "#0D70DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextQuick);
export default __webpack_public_path__ + "static/media/next-quick.27de0d896bf4d41d46fa528ebce69b21.svg";
export { ForwardRef as ReactComponent };